// extracted by mini-css-extract-plugin
export default {"container":"videos__container__q7z3j","ageGate":"videos__ageGate__wkzYL","fadeOut":"videos__fadeOut__dRZtp"};